interface GlobalConfig {
  country: "United States" | "Canada";
}

const DefaultGlobals: GlobalConfig = {
  country: "United States",
};

export type { GlobalConfig };
export { DefaultGlobals };
